import { Injectable, inject } from '@angular/core';
import {Subject} from 'rxjs/internal/Subject';
import {LoaderService} from './loader.service';
import {environment} from '../../../environments/environment';

class Elem {
    sub: Subject<boolean> = new Subject<boolean>();
    methode: string;
    url: string;
    urlBase: string;
    loader = true;
}

@Injectable({
    providedIn: 'root',
})
export class SubscribeService {
    private loaderService = inject(LoaderService);

    public listOld: any = {};
    public list: any[] = [];

    public addRef(url: string, methode: string = 'get'): Subject<boolean> {
        //Suppression de l'ancienne requete
        const oldSub = this.list.filter(
            (sub: Elem) =>
                sub.urlBase === this.urlBase(url) && sub.methode === methode
        );
        if (oldSub && oldSub.length) {
            oldSub.map(sub => {
                this.closeRef(sub);
            });
            this.list = [
                ...this.list.filter(
                    (sub: Elem) =>
                        sub.urlBase !== this.urlBase(url) &&
                        sub.methode !== methode
                ),
            ];
        }

        //Ajout d'un nouveau
        const tmp: Elem = new Elem();
        tmp.methode = methode;
        tmp.url = url;
        tmp.urlBase = this.urlBase(url);
        if (
            !(url.indexOf('/api/fields/') !== -1) &&
            !(url.indexOf('noLoader') !== -1)
        ) {
            tmp.loader = true;
        }
        this.list.push(tmp);

        return this.list[this.list.length - 1].sub;
    }

    public closeAllRef(supprime: boolean = false) {
        this.list.map((elem: Elem) => {
            this.closeRef(elem);
        });
        if (supprime) {
            this.list = [];
        }
        if (environment.annulationRequetesDouble) {
            this.loaderService.resetLoader();
        }
    }

    closeRef(elem: Elem) {
        if (environment.annulationRequetesDouble) {
            elem.sub.next(true);
            elem.sub.unsubscribe();
            if (elem.loader) {
                this.loaderService.resetLoader();
            }
        }
    }

    private urlBase(url: string): string {
        let urlBase: string = url;
        if (url.split('?').length) {
            urlBase = url.split('?')[0];
        }
        return urlBase;
    }
}
